import PictureInPicture from "../../components/Assembler/JSON/PictureInPicture";

import ScreenShareService from "../../infrastructure/Services/ScreenShareService";

import { ITypeMedia } from "../../interfaces/Artists";

import type Cameras from "../Devices/Cameras";

import { v4 as uuidv4 } from "uuid";

/**
 * Perfil "Clases Virtuales": pantalla compartida (slides/presentación) de fondo +
 * cámara del docente en PiP. Mismo layout base que grabación/gamer (PictureInPicture):
 * el screen-share cubre la presentación y la cámara va sobre la esquina.
 */
class VirtualClassesAdapterModel {
  private Model = PictureInPicture;

  private Cameras: Cameras | null = null;

  constructor() {
    this.Model.id = uuidv4();
  }

  async setCameras(cameras: Cameras) {
    this.Cameras = cameras;

    await this.setHardware();
  }

  private async setHardware() {
    // Pantalla compartida por defecto (presentación / slides)

    const { defaultDisplay } = await this.getDefaultDisplay();

    // Área de fondo

    const areaBackground = this.Model.areas[0];

    // Aplicar la pantalla compartida al fondo

    areaBackground.media.resource = {
      id: defaultDisplay.id,

      type: ITypeMedia.display,

      source: {
        sourceId: defaultDisplay.id,

        width: defaultDisplay.width,

        height: defaultDisplay.height,
      },

      settings: {
        volume: 0,
      },
    };

    // Cámara del docente por defecto

    const defaultCamera = this.getDefaultCamera();

    // Área de la cámara (PiP)

    const areaCamera = this.Model.areas[1];

    // Aplicar la cámara al PiP

    areaCamera.media.resource = {
      id: defaultCamera.id,

      type: ITypeMedia.camera,

      source: {
        deviceId: defaultCamera.deviceId,

        groupId: defaultCamera.groupId,

        kind: defaultCamera.kind,

        label: defaultCamera.label,
      },
    };

    this.Model.areas = [areaBackground, areaCamera];
  }

  private getDefaultCamera() {
    const cameras = this.Cameras?.getAll();

    const device = cameras?.[0] ?? null;

    const cameraDefault = device;

    const defaultInfoDevice = {
      id: cameraDefault?.id || "",

      deviceId: cameraDefault?.deviceInfo.deviceId || "",

      groupId: cameraDefault?.deviceInfo.groupId || "",

      kind: cameraDefault?.deviceInfo.kind || "",

      label: cameraDefault?.deviceInfo.label || "",
    };

    return defaultInfoDevice;
  }

  private async getDefaultDisplay() {
    const displayService = new ScreenShareService("api");

    const displays = await displayService.getSources();

    const defaultDisplay = displays[0];

    return {
      defaultDisplay,
    };
  }

  getModel() {
    return this.Model;
  }
}

export default VirtualClassesAdapterModel;
